import React from "react";
import {
  ZRCAttachemntImg,
  zRCAttachemntImg,
  ZRCAttachemntBase,
  zRCAttachemntBase,
  ZRCAttachment,
} from "src/businessServices/services/bsChat/rocketChat/rocketChat.types";
import { AnyZodObject, z } from "zod";
import { BaseAttachment } from "./components/BaseAttachment";
import { ImgAttachment } from "./components/ImgAttachment";

export type AttachmentRenderParams = {
  createMsg: (text: string) => React.ReactNode;
};

type TypeTester = {
  tester: AnyZodObject | z.ZodType;
  render: (
    attachment: ZRCAttachment,
    params: AttachmentRenderParams,
  ) => React.ReactNode;
};

export const zRCAttachemntTesters: TypeTester[] = [
  {
    tester: zRCAttachemntImg,
    render: (attachment) => (
      <ImgAttachment data={attachment as ZRCAttachemntImg} />
    ),
  },
  {
    tester: zRCAttachemntBase,
    render: (attachment) => (
      <BaseAttachment data={attachment as ZRCAttachemntBase} />
    ),
  },
];

export const defineAttachment = (
  attachment: ZRCAttachment,
  params: AttachmentRenderParams,
) => {
  const data = zRCAttachemntTesters.map(({ render, tester }) => {
    try {
      tester.parse(attachment);
      return render(attachment, params);
    } catch (e) {
      return null;
    }
  });
  return data.filter((cmp) => !!cmp)[0];
};
